import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchDiscussion, restoreFromTrash } from "~/store/actions/actions.discussions";
import { permanentlyDelete } from "~/store/actions/actions.trash";
import { getDiscussionById } from "~/store/selectors/selector.discussions";
import { getLoggedUser } from "~/store/selectors/selector.users";

export const useDiscussionActions = (id, projectId) => {
  const dispatch = useDispatch();
  const discussion = useSelector((state) => getDiscussionById(state, id));
  const navigate = useNavigate();
  const loggedUser = useSelector(getLoggedUser);

  const handleRestore = useCallback(async () => {
    await dispatch(restoreFromTrash(id));
    await dispatch(fetchDiscussion(projectId, id));
  }, [dispatch, id, projectId]);

  const handleDelete = useCallback(async () => {
    await dispatch(permanentlyDelete("Discussion", id));
    navigate(`/projects/${projectId}/discussions`);
  }, [dispatch, navigate, id, projectId]);

  const canRestore = (discussion?.is_trashed && loggedUser.isOwner()) || discussion?.trashed_by_id === loggedUser.id;

  const canPermanentlyDelete = discussion?.is_trashed && loggedUser.class === "Owner";

  return {
    handleRestore,
    handleDelete,
    canRestore,
    canPermanentlyDelete,
  };
};
